import { render, staticRenderFns } from "./AccordionSubItemResearch.vue?vue&type=template&id=6cd4c9ea&scoped=true"
import script from "./AccordionSubItemResearch.vue?vue&type=script&lang=js"
export * from "./AccordionSubItemResearch.vue?vue&type=script&lang=js"
import style0 from "./AccordionSubItemResearch.vue?vue&type=style&index=0&id=6cd4c9ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd4c9ea",
  null
  
)

export default component.exports